__turbopack_context__.v({
  "header": "Y5MWMG_header",
  "theme-toggle-pop": "Y5MWMG_theme-toggle-pop",
  "themeIcon": "Y5MWMG_themeIcon",
  "themeIconAnimating": "Y5MWMG_themeIconAnimating",
});
